import {
  ADMIN_API_PREFIX,
  BASE_PORT,
  BASE_URL,
  USER_API_PREFIX,
  MAP_API_URL,
} from "../services/constant";

const endpoint = {
  login: `${BASE_URL}/${ADMIN_API_PREFIX}/login`,
  logout: `${BASE_URL}/${ADMIN_API_PREFIX}/logout`,
  adminDetails: `${BASE_URL}/${ADMIN_API_PREFIX}/admindetails`,
  createadmin: `${BASE_URL}/${ADMIN_API_PREFIX}/createAdmin`,
  allAdmin: `${BASE_URL}/${ADMIN_API_PREFIX}/allAdmin`,
  account_profile_status: `${BASE_URL}/${ADMIN_API_PREFIX}/account_profile_status`,
  deleteByid: `${BASE_URL}/${ADMIN_API_PREFIX}/adminByid`,

  // Driver EndPoints --------------->>>>>>>>
  addDriver: `${BASE_URL}/${ADMIN_API_PREFIX}/addDriver`,
  addCarInfo: `${BASE_URL}/api/driver-car-info`,
  addCarDoc: `${BASE_URL}/api/driver-car-documents`,
  addDriverEmergency: `${BASE_URL}/api/driver-emergency-info`,

  carInfo: `${BASE_URL}/api/CarInfo`,
  carDocuInfo: `${BASE_URL}/api/CarDocumentInfo`,
  driverEmergencyInfo: `${BASE_URL}/api/DriverEmergecnyInfo`,

  allDrivers: `${BASE_URL}/${ADMIN_API_PREFIX}/allDrivers`,
  getDriversById: `${BASE_URL}/${ADMIN_API_PREFIX}/getDriverById`,
  deleteDriver: `${BASE_URL}/api/driverDelete`,

  // For Website Book Rideee -------->>>>>>>
  bookRide: `${BASE_URL}/${ADMIN_API_PREFIX}/bookRideByWebsite`,

  // For Website Send Enquiry -------->>>>>>>
  sendEnquiry: `${BASE_URL}/${ADMIN_API_PREFIX}/sendEnquiry`,

  // Users EndPoints  ------------------->>>>>>>>>>
  allUsers: `${BASE_URL}/${ADMIN_API_PREFIX}/allUsers`,

  userDetails: `${BASE_URL}/${USER_API_PREFIX}/user`,
  userLogin: `${BASE_URL}/${USER_API_PREFIX}/user-signin`,
  signUp: `${BASE_URL}/${USER_API_PREFIX}/user`,
  verifyOTP: `${BASE_URL}/${USER_API_PREFIX}/user-otp-verify`,
  resendOTP: `${BASE_URL}/${USER_API_PREFIX}/resend-otp`,
  userLogout: `${BASE_URL}/${USER_API_PREFIX}/logout`,

  // Others EndPointsss ------------------------->>>>>>>>>
  states: `${BASE_URL}/api/states`,
  cities: `${BASE_URL}/api/citiesBystate-id`,
  carTypes: `${BASE_URL}/api/car-type`,

  // Ride && Booking EndPoints ------------------>>>>>>>>>
  getAllBooking: `${BASE_URL}/${ADMIN_API_PREFIX}/getAllRides`,

  getAllReviews: `${BASE_URL}/${ADMIN_API_PREFIX}/getAllReviews`,

  // Get All Wallet Report EndPoints ------------------>>>>>>>>>
  getAllWalletReport: `${BASE_URL}/${ADMIN_API_PREFIX}/getAllWalletReport`,
  getAllCounts: `${BASE_URL}/${ADMIN_API_PREFIX}/getAllCounts`,

  // Mappp EndPointss --------------->>>>>>>>>>
  searchLocation: `${MAP_API_URL}/search-location`,
};

// const endpoint = {
//   login: `${BASE_URL}:${BASE_PORT}/${ADMIN_API_PREFIX}/login`,
//   logout: `${BASE_URL}:${BASE_PORT}/${ADMIN_API_PREFIX}/logout`,
//   adminDetails: `${BASE_URL}:${BASE_PORT}/${ADMIN_API_PREFIX}/admindetails`,
//   createadmin: `${BASE_URL}:${BASE_PORT}/${ADMIN_API_PREFIX}/createAdmin`,
//   allAdmin: `${BASE_URL}:${BASE_PORT}/${ADMIN_API_PREFIX}/allAdmin`,
//   account_profile_status: `${BASE_URL}:${BASE_PORT}/${ADMIN_API_PREFIX}/account_profile_status`,
//   deleteByid: `${BASE_URL}:${BASE_PORT}/${ADMIN_API_PREFIX}/adminByid`,

//   // Driver EndPoints --------------->>>>>>>>
//   addDriver: `${BASE_URL}:${BASE_PORT}/${ADMIN_API_PREFIX}/addDriver`,
//   addCarInfo: `${BASE_URL}:${BASE_PORT}/api/driver-car-info`,
//   addCarDoc: `${BASE_URL}:${BASE_PORT}/api/driver-car-documents`,
//   addDriverEmergency: `${BASE_URL}:${BASE_PORT}/api/driver-emergency-info`,

//   carInfo: `${BASE_URL}:${BASE_PORT}/api/CarInfo`,
//   carDocuInfo: `${BASE_URL}:${BASE_PORT}/api/CarDocumentInfo`,
//   driverEmergencyInfo: `${BASE_URL}:${BASE_PORT}/api/DriverEmergecnyInfo`,

//   allDrivers: `${BASE_URL}:${BASE_PORT}/${ADMIN_API_PREFIX}/allDrivers`,
//   getDriversById: `${BASE_URL}:${BASE_PORT}/${ADMIN_API_PREFIX}/getDriverById`,
//   deleteDriver: `${BASE_URL}:${BASE_PORT}/api/driverDelete`,

//   // For Website Book Rideee -------->>>>>>>
//   bookRide: `${BASE_URL}:${BASE_PORT}/${ADMIN_API_PREFIX}/bookRideByWebsite`,

//   // For Website Send Enquiry -------->>>>>>>
//   sendEnquiry: `${BASE_URL}:${BASE_PORT}/${ADMIN_API_PREFIX}/sendEnquiry`,

//   // Users EndPoints  ------------------->>>>>>>>>>
//   allUsers: `${BASE_URL}:${BASE_PORT}/${ADMIN_API_PREFIX}/allUsers`,

//   userDetails: `${BASE_URL}:${BASE_PORT}/${USER_API_PREFIX}/user`,
//   userLogin: `${BASE_URL}:${BASE_PORT}/${USER_API_PREFIX}/user-signin`,
//   signUp: `${BASE_URL}:${BASE_PORT}/${USER_API_PREFIX}/user`,
//   verifyOTP: `${BASE_URL}:${BASE_PORT}/${USER_API_PREFIX}/user-otp-verify`,
//   resendOTP: `${BASE_URL}:${BASE_PORT}/${USER_API_PREFIX}/resend-otp`,
//   userLogout: `${BASE_URL}:${BASE_PORT}/${USER_API_PREFIX}/logout`,

//   // Others EndPointsss ------------------------->>>>>>>>>
//   states: `${BASE_URL}:${BASE_PORT}/api/states`,
//   cities: `${BASE_URL}:${BASE_PORT}/api/citiesBystate-id`,
//   carTypes: `${BASE_URL}:${BASE_PORT}/api/car-type`,

//   // Ride && Booking EndPoints ------------------>>>>>>>>>
//   getAllBooking: `${BASE_URL}:${BASE_PORT}/${ADMIN_API_PREFIX}/getAllRides`,

//   getAllReviews: `${BASE_URL}:${BASE_PORT}/${ADMIN_API_PREFIX}/getAllReviews`,

//   // Get All Wallet Report EndPoints ------------------>>>>>>>>>
//   getAllWalletReport: `${BASE_URL}:${BASE_PORT}/${ADMIN_API_PREFIX}/getAllWalletReport`,
//   getAllCounts: `${BASE_URL}:${BASE_PORT}/${ADMIN_API_PREFIX}/getAllCounts`,

//   // Mappp EndPointss --------------->>>>>>>>>>
//   searchLocation: `${MAP_API_URL}/search-location`,
// };

export default endpoint;
